import { getDeviceType } from "../../common/constants/variables/globalVariables";
import { formState } from "../form/FormState";
class GalleryTypology {
    constructor() {
        this.positionSlide = 1;
        // Binds the functions so they maintain the context of the class
        this.closeModalGallery = this.closeModalGallery.bind(this);
        this.initTourMode();
        this.initTourBack();
    }
    /**
     * Opens the desktop version of the gallery modal.
     * @param {string} id - The number of the image to change (positive to go forward, negative to go back).
     * @returns {void}
     */
    openModalTypology(id) {
        document.getElementById(id).style.display = "flex";
        let formModal = Array.from(document.getElementsByClassName("form_contac--modal"));
        formModal[0].classList.add("open");
    }
    /**
     * Closes the gallery modal, depending on the section type (blueprint or gallery).
     * @param {string} section - The device type, which can be 'blueprint' or 'gallery'.
     * @returns {void}
     */
    closeModalGallery(section) {
        const modalId = section == 'blueprint' ? 'modalPlans' : 'modalGallery';
        const modal = document.getElementById(modalId);
        modal.style.display = "none";
        formState.manageState('formName', '#typologyForm'); // Set the form modal ID
    }
    handleTourMode(isTourActive) {
        const isLandscape = window.innerWidth > window.innerHeight;
        const valueDevice = getDeviceType();
        const isMobile = valueDevice === 'mobile';
        if (isTourActive && isLandscape && isMobile) {
            document.body.classList.add('tour-mode');
        }
        else {
            document.body.classList.remove('tour-mode');
        }
    }
    initTourMode() {
        const tabs = document.querySelectorAll('[data-bs-toggle="pill"]');
        tabs.forEach(tab => {
            tab.addEventListener('shown.bs.tab', (e) => {
                const target = e.target.getAttribute('data-bs-target');
                if (target === '#typology-tour') {
                    this.handleTourMode(true);
                }
                else {
                    this.handleTourMode(false);
                }
            });
        });
        window.addEventListener('resize', () => {
            var _a;
            const isTourActive = (_a = document.getElementById('typology-tour')) === null || _a === void 0 ? void 0 : _a.classList.contains('show');
            this.handleTourMode(!!isTourActive);
        });
    }
    initTourBack() {
        const btn = document.querySelector('.tour-back');
        btn === null || btn === void 0 ? void 0 : btn.addEventListener('click', () => {
            document.body.classList.remove('tour-mode');
            const fallbackTab = document.querySelector('[data-bs-target="#typology-images"]');
            fallbackTab === null || fallbackTab === void 0 ? void 0 : fallbackTab.click();
        });
    }
}
export { GalleryTypology };
